import app from '../../scripts/app';
import template from './retry-notice.jade';

/* см. app/scripts/services/retry.interceptor.js */

app.directive('cianAfRetryNotice', [
  '$rootScope',
  'retryService',
  ($rootScope, retryService) => ({
    template,
    transclude: true,
    bindToController: {
      shortCode: '@',
    },
    controller: [
      '$scope',
      function ($scope) {
        this.noticeVisible = false;
        this.buttonDisabled = false;
        const shortCodes = this.shortCode.split(' ');
        const failedShortCodes = new Set();

        const isMyShortCode = shortCode => shortCodes.includes(shortCode);

        this.retryRun = () => {
          failedShortCodes.forEach(code => $rootScope.$emit(retryService.events.requestRepeat, code));
          this.buttonDisabled = true;
        };

        const requestRepeatAlreadyInProgressListener = $rootScope.$on(
          retryService.events.requestRepeatAlreadyInProgress,
          (event, shortCode) => {
            if (isMyShortCode(shortCode)) {
              this.buttonDisabled = true;
            }
          },
        );

        const requestFailedListener = $rootScope.$on(retryService.events.requestFailed, (event, shortCode) => {
          if (isMyShortCode(shortCode)) {
            this.noticeVisible = true;
            this.buttonDisabled = false;
            failedShortCodes.add(shortCode);
          }
        });

        const requestSuccessfulListener = $rootScope.$on(retryService.events.requestSuccessful, (event, shortCode) => {
          if (isMyShortCode(shortCode)) {
            failedShortCodes.delete(shortCode);
            if (failedShortCodes.size === 0) {
              this.noticeVisible = false;
              this.buttonDisabled = false;
            }
          }
        });

        $scope.$on('$destroy', () => {
          requestRepeatAlreadyInProgressListener();
          requestFailedListener();
          requestSuccessfulListener();
        });
      },
    ],
    controllerAs: 'retryNotice',
  }),
]);
